import React from 'react'
import BannerMainImageSection from '../../../bannerMainImageSection'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import * as E from '../homeElements'
import { Row, Col } from 'react-bootstrap'
import { PrimaryButton } from '@mmsg/louie'
import ContactUsDialog from 'components/dialog/contactUsDialog'
import { IEstimateAcceptedStageProps } from '../stages/interfaces/IEstimateAcceptedStageProps'
import { FinAppStatusValue } from 'utils/type'
import { Link } from 'react-router-dom'

const EstimateAcceptedStage = (props: IEstimateAcceptedStageProps) => {
  const { firstName, consultantFirstName, isConsultant, finAppStatus } = props
  
  return (
    <>
      <BannerMainImageSection>
        <E.WhiteHeading>OLY NOVATED LEASE</E.WhiteHeading>
        <h1 style={{color:'#fff'}}>Ready to jump into the driver&rsquo;s seat?</h1>
      </BannerMainImageSection>


      <BannerBrandImageSection id="maincontent">
        <E.ContainerBlock>
          <E.BannerButtonLinkParent>
            <Col sm={8}>
              <E.BannerButtonTitleRow>
                Hi {firstName}, the estimate for your Oly novated lease is ready! 
                Check out your options now or keep reading to learn what the next steps are.  
              </E.BannerButtonTitleRow>
              <Row>
                <div>
                  Need a quick reminder on what a novated lease is and how it could get you behind the wheel of a new car for less $$? Oly’s got you… 
                  {(finAppStatus.status == FinAppStatusValue.NOTSTARTED ||
                    finAppStatus.status == FinAppStatusValue.STARTED) && finAppStatus.url != null && (
                    <>
                      {' '}
                      Please click on 'Start finance application' to complete
                      your Finance application for {consultantFirstName} to
                      start working on your proposal and to get quick financier
                      approval.
                    </>
                  )}

                </div>
              </Row>
            </Col>
            <E.BannerButtonLinkChild>
              {isConsultant ? (
                <div className="text-center">
                  {(finAppStatus.status == FinAppStatusValue.NOTSTARTED ||
                    finAppStatus.status == FinAppStatusValue.STARTED) && finAppStatus.url != null &&  (
                    <>
                      <PrimaryButton
                        extendInMob
                        variant="invertColor"
                        id="nextstepcontent.insuranceconsentdisabled"
                        style={{ maxWidth: '270px' }}
                        disabled
                      >
                        Start finance application
                      </PrimaryButton>
                      <br />
                      <br />
                    </>
                  )}
                  <E.BannerPrimaryInverted
                    disabled
                    id="estimateacceptedstate.contactreadonly"
                  >
                    Contact my consultant
                  </E.BannerPrimaryInverted>
                </div>
              ) : (
                <div className="text-center">
                  {(finAppStatus.status == FinAppStatusValue.NOTSTARTED ||
                    finAppStatus.status == FinAppStatusValue.STARTED) && finAppStatus.url != null && (
                    <>
                      <Link
                        to={{ pathname: finAppStatus.url }}
                        target="_blank"
                        rel="noopener noreferrer"
                        tabIndex={-1}
                      >
                        <PrimaryButton
                          extendInMob
                          id="nextstepcontent.insuranceconsentdisabled"
                          style={{ maxWidth: '270px' }}
                        >
                          Start finance application
                        </PrimaryButton>
                      </Link>
                      <br />
                      <br />
                    </>
                  )}
                  <ContactUsDialog
                    invertColor={true}
                    className="text-brand font-weight-bold"
                    theme="button"
                    size="lg"
                    launchText="Contact my consultant"
                  />
                </div>
              )}
            </E.BannerButtonLinkChild>
          </E.BannerButtonLinkParent>
        </E.ContainerBlock>
      </BannerBrandImageSection>
    </>
  )
}

export default EstimateAcceptedStage
